import { Button } from "@a2z/ui";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

export interface OrdersEmptyStateProps {
  hasFilters: boolean;
  onClear: () => void;
}

export function OrdersEmptyState({ hasFilters, onClear }: OrdersEmptyStateProps) {
  const t = useTranslations();
  return (
    <div className="flex flex-col items-center gap-3 rounded-[14px] border border-dashed border-[color:var(--border-strong)] bg-[color:var(--surface)] px-6 py-20 text-center">
      <span
        aria-hidden="true"
        className="flex h-14 w-14 items-center justify-center rounded-[14px] bg-[color:var(--background-muted)] text-[color:var(--text-muted)]"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      </span>
      <div className="text-[15px] font-semibold text-[color:var(--text-primary)]">
        {t(keys.orders.emptyTitle)}
      </div>
      <div className="text-[13px] text-[color:var(--text-muted)]">
        {t(keys.orders.emptyBody)}
      </div>
      {hasFilters ? (
        <Button
          variant="outline"
          size="md"
          onClick={onClear}
          className="mt-2"
        >
          {t(keys.orders.clearFilters)}
        </Button>
      ) : null}
    </div>
  );
}
